var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isValidElement } from 'react';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
/**
 * Global search and replace in a string using a dictionary
 *
 * @param {string} str - template string that includes tokens
 * @param {object} dict - dictionary of key value pairs (eg. { [token:device]: 'iPhone 14' })
 * @returns {string}
 */
export var replaceTemplateTags = function (str, dict) {
    return Object.keys(dict).reduce(function (acc, key) {
        var item = acc.split("[".concat(key, "]")).join(dict[key]);
        return item;
    }, str);
};
/**
 * Search and replace template tags in contentful rich text
 * fields recursively using a a provided dictionary
 *
 * NOTE: To keep complexity small do not pass a large dictionary. Instead
 * keep the dictionary as small as possible (only what needs replacements)
 *
 * @param {object} node - contentful rich text node
 * @param {object} dict - dictionary of key value pairs (eg. { [token:device]: 'iPhone 14' })
 * @return {object}
 */
export var contentfulReplaceTagsRichText = function (node, dict) {
    if (typeof node !== 'object') {
        return node;
    }
    if (Array.isArray(node.content) && node.content.length > 0) {
        return __assign(__assign({}, node), { content: node.content.map(function (item) { return contentfulReplaceTagsRichText(item, dict); }) });
    }
    if (node.value) {
        return __assign(__assign({}, node), { value: replaceTemplateTags(node.value, dict) });
    }
    return node;
};
export var getParagraphSize = function (content, node, paragraphSize, listOptions) {
    var _a, _b, _c, _d, _e;
    var listSize = (_b = (_a = listOptions === null || listOptions === void 0 ? void 0 : listOptions.list) === null || _a === void 0 ? void 0 : _a.variant) === null || _b === void 0 ? void 0 : _b.size;
    var contentContainsList = content.content.find(function (node) { return node.nodeType === 'unordered-list'; }) ||
        content.content.find(function (node) { return node.nodeType === 'ordered-list'; });
    var contentContainsListAndParagraph = contentContainsList && content.content.find(function (node) { return node.nodeType === 'paragraph'; });
    if (typeof node === 'string' || isValidElement(node))
        return paragraphSize;
    return ((_d = (_c = contentContainsListAndParagraph === null || contentContainsListAndParagraph === void 0 ? void 0 : contentContainsListAndParagraph.content) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.value) === ((_e = node.content) === null || _e === void 0 ? void 0 : _e[0].value) ||
        contentContainsList
        ? listSize
        : paragraphSize;
};
export var isRichTextEmpty = function (richText) {
    var _a, _b;
    var result = false;
    try {
        result = ((_b = (_a = richText === null || richText === void 0 ? void 0 : richText.content[0]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.length) === 0;
    }
    catch (err) { }
    return result;
};
/**
 * Convert rich text object into plain string, so that it can be passed as string
 * in uds terms and conditions component and footnote component.
 * @param {object} content content to be convert into plain string value.
 * @returns string
 */
export var richTextWithPlainString = function (content) {
    return content && documentToPlainTextString(content);
};
export var getModifiedColorArgs = function (args) {
    var _a, _b, _c, _d;
    var strong = (_a = args['color.strong']) !== null && _a !== void 0 ? _a : 'alternative2';
    var paragraph = args['color.paragraph'];
    var heading = (_b = args['color.heading']) !== null && _b !== void 0 ? _b : 'alternative2';
    var link = (_c = args['color.link']) !== null && _c !== void 0 ? _c : 'alternative';
    var embeddedInline = (_d = args['color.embeddedInline']) !== null && _d !== void 0 ? _d : 'light';
    return __assign(__assign({}, args), { color: { strong: strong, paragraph: paragraph, heading: heading, link: link, embeddedInline: embeddedInline } });
};
